import { createFileRoute } from "@tanstack/react-router";
import DetailedTabPanel from "@/components/dashboard/detailed-tab-panel";

export const Route = createFileRoute("/_app/dashboard/detailed/")({
	component: DetailedTabPanel,
});
